import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { useCampaignAds } from 'src/services/orpc/campaignAds'
import { cx } from 'src/utils/cx'
import { startEventGroup, track } from 'src/utils/tracker'

/**
 * PixAI Membership Promotion Banner
 *
 * @param props.style - CSS style overrides. Setting `height` is not recommended
 */
export default function MembershipBanner(
  props: { scene?: string; onClick?: () => void } & StyleProps,
) {
  const { i18n } = useTranslation()
  const { data: campaignData } = useCampaignAds({
    lang: i18n.language,
    category: 'profileMembershipBanner',
  })
  const campaignItem = campaignData?.[0]

  if (!campaignItem?.media) return null

  return (
    <Link
      to={campaignItem?.targetUrl ?? '/membership/plans'}
      className={cx(
        'px-4 py-4 flex flex-col items-start bg-cover aspect-[3]',
        props.className,
      )}
      style={{
        backgroundImage: `
          url(${campaignItem?.media})`,
        maxHeight: 150,
        ...props.style,
      }}
      onClick={() => {
        const trackingLocation = props.scene
        track('enter_member_click', {
          location: trackingLocation,
          tracking_id: campaignItem?.trackingId,
        })
        startEventGroup('member_source', trackingLocation, { persistent: true })
        props.onClick?.()
      }}
    />
  )
}
